function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { values } from 'ramda';
import ApiConstants from 'invision-core/src/api/constants';
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { buildSearchBulkServicesRequest } from '../helpers/bulk.services.action.helper';
import { NUMBER_OF_ENTITLEMENTS_TO_DISPLAY } from '../../components/customer/dashboard/dbssDashboard/servicesAndOffers/services.and.offers.contants';
var SERVICE_ACTION_URL = {
  SUSPEND_SERVICES: 'SuspendServices',
  RESUME_SERVICES: 'RestoreServices'
};
export var SET_BULK_SERVICES_STATUS_FILTER = 'SET_BULK_SERVICES_STATUS_FILTER';
export var setBulkServicesStatusFilter = function setBulkServicesStatusFilter(includeStatusFilter) {
  return {
    type: SET_BULK_SERVICES_STATUS_FILTER,
    payload: includeStatusFilter
  };
};
export var SET_CURRENT_PAGE = 'SET_BULK_SERVICES_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var SET_BULK_SERVICES_SEARCH_STRING = 'SET_BULK_SERVICES_SEARCH_STRING';
export var setBulkServicesSearchString = function setBulkServicesSearchString(searchString) {
  return {
    type: SET_BULK_SERVICES_SEARCH_STRING,
    payload: searchString
  };
};
export var SET_BULK_SERVICES_PAGE_SIZE = 'SET_BULK_SERVICES_PAGE_SIZE';
export var setBulkServicesPageSize = function setBulkServicesPageSize(pageSize) {
  return {
    type: SET_BULK_SERVICES_PAGE_SIZE,
    payload: pageSize
  };
};
export var REMOVE_BULK_SERVICES_STATUS_FILTER = 'REMOVE_BULK_SERVICES_STATUS_FILTER';
export var removeBulkServicesStatusFilter = function removeBulkServicesStatusFilter() {
  return {
    type: REMOVE_BULK_SERVICES_STATUS_FILTER
  };
};
export var SEARCH_SERVICES_CONSTANTS = {
  BEGIN: 'SEARCH_SERVICES_BEGIN',
  SUCCESS: 'SEARCH_SERVICES_SUCCESS',
  FAILURE: 'SEARCH_SERVICES_FAILURE'
};
export var searchServicesPromise = function searchServicesPromise(dispatch, params, requestObj) {
  return thunkHelper(dispatch, values(SEARCH_SERVICES_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/SearchServices',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, params.customerId),
    data: buildSearchBulkServicesRequest(params)
  }, requestObj);
};
export var searchServices = function searchServices(params, requestObj) {
  return function (dispatch) {
    return searchServicesPromise(dispatch, params, requestObj);
  };
};
export var SUSPEND_RESUME_SERVICES_CONSTANTS = {
  BEGIN: 'SUSPEND_RESUME_SERVICES_BEGIN',
  SUCCESS: 'SUSPEND_RESUME_SERVICES_SUCCESS',
  FAILURE: 'SUSPEND_RESUME_SERVICES_FAILURE'
};
var suspendOrResumeServicesPromise = function suspendOrResumeServicesPromise(dispatch, customerId, requestObj, isActive) {
  return thunkHelper(dispatch, values(SUSPEND_RESUME_SERVICES_CONSTANTS), {
    method: 'post',
    url: "SubscriberManagement/".concat(isActive ? SERVICE_ACTION_URL.SUSPEND_SERVICES : SERVICE_ACTION_URL.RESUME_SERVICES),
    data: requestObj,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var suspendOrResumeServices = function suspendOrResumeServices(customerId, requestObj, isActive) {
  return function (dispatch) {
    return suspendOrResumeServicesPromise(dispatch, customerId, requestObj, isActive);
  };
};
export var SET_SERVICES_TYPE_OF_SERVICE_FILTER = 'SET_SERVICES_TYPE_OF_SERVICE_FILTER';
export var setServicesTypeOfServiceFilter = function setServicesTypeOfServiceFilter(includeTypeOfServiceFilter) {
  return {
    type: SET_SERVICES_TYPE_OF_SERVICE_FILTER,
    payload: includeTypeOfServiceFilter
  };
};
export var SET_SELECTED_SERVICE_IDENTIFIER = 'SET_SELECTED_SERVICE_IDENTIFIER';
export var setSelectedServiceIdentifier = function setSelectedServiceIdentifier(serviceIdentifier) {
  return {
    type: SET_SELECTED_SERVICE_IDENTIFIER,
    payload: serviceIdentifier
  };
};
export var SET_SELECTED_ACCOUNT_LEVEL = 'SET_SELECTED_ACCOUNT_LEVEL';
export var setSelectAccountLevel = function setSelectAccountLevel(selectTab) {
  return {
    type: SET_SELECTED_ACCOUNT_LEVEL,
    payload: selectTab
  };
};
export var RETRIEVE_SERVICE_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_SERVICE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_SERVICE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_SERVICE_DETAILS_FAILURE'
};
export var retrieveServiceDetailsPromise = function retrieveServiceDetailsPromise(dispatch, customerId) {
  var serviceIdentifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return thunkHelper(dispatch, values(RETRIEVE_SERVICE_DETAILS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerServiceDetails',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      IncludePaymentInstrumentAssociations: true,
      IncludePolicyCounters: true,
      MaxNumberOfServiceEntitlements: NUMBER_OF_ENTITLEMENTS_TO_DISPLAY,
      MaxNumberOfSharedEntitlements: NUMBER_OF_ENTITLEMENTS_TO_DISPLAY,
      ServiceIdentifiers: serviceIdentifiers
    }
  });
};
export var retrieveServiceDetails = function retrieveServiceDetails(customerId, serviceIdentifiers) {
  return function (dispatch) {
    return retrieveServiceDetailsPromise(dispatch, customerId, serviceIdentifiers);
  };
};
export var UPDATE_CUSTOMIZED_SERVICE_TAX = {
  BEGIN: 'UPDATE_CUSTOMIZED_SERVICE_TAX_BEGIN',
  SUCCESS: 'UPDATE_CUSTOMIZED_SERVICE_TAX_SUCCESS',
  FAILURE: 'UPDATE_CUSTOMIZED_SERVICE_TAX_FAILURE'
};
export var updateCustomizedServiceTaxPromise = function updateCustomizedServiceTaxPromise(dispatch, customizedServiceTax, customerId) {
  return thunkHelper(dispatch, values(UPDATE_CUSTOMIZED_SERVICE_TAX), {
    method: 'post',
    url: 'SubscriberManagement/UpdateServiceTaxCustomization',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ServiceTaxCustomization: customizedServiceTax.ServiceTaxCustomization
    }
  });
};
export var updateCustomizedServiceTax = function updateCustomizedServiceTax(customizedServiceTax, customerId) {
  return function (dispatch) {
    return updateCustomizedServiceTaxPromise(dispatch, customizedServiceTax, customerId);
  };
};